<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <!-- 基本信息 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="true"
            :activityId="71"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="活动设置"></jd-title>
          <div class="mt20">
            <el-form-item required label="游戏模式:">
              <el-radio-group
                :disabled="isStartEdit"
                @change="gainDrawNumberTypeChange"
                v-model="ruleDTO.gameMode"
              >
                <el-radio :label="0">敲敲乐</el-radio>
                <el-radio :label="1">抓娃娃</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="游戏设置:" required>
              <div class="limit">
                <el-input
                  class="mr4"
                  v-model.number="ruleDTO.gameTime"
                  placeholder="请输入..."
                  style="width: 80px"
                  type="number"
                  :max="999999"
                  :min="1"
                  @input="validatePositiveInteger('ruleDTO.gameTime')"
                ></el-input>
                秒倒计时，{{
                  ruleDTO.gameMode == 0 ? "敲击一个元素得" : "抓到一个娃娃得"
                }}<el-input
                  class="ml4 mr4"
                  v-model.number="ruleDTO.gameScorePer"
                  placeholder="请输入..."
                  style="width: 80px"
                  type="number"
                  :max="999999"
                  :min="1"
                  @input="validatePositiveInteger('ruleDTO.gameScorePer')"
                ></el-input>分
                <!-- 分，预估最高可得总分为：<el-input
                  class="mr4"
                  v-model.number="ruleDTO.foreScoreTotal"
                  placeholder="请输入..."
                  style="width: 80px"
                  disabled
                ></el-input>
                分（仅供参考） -->
              </div>
            </el-form-item>
            <el-form-item label="赠送游戏次数:">
              <div class="limit">
                初始赠送
                <el-input
                  class="ml4 mr4"
                  v-model.number="ruleDTO.giveTimes"
                  placeholder="请输入..."
                  style="width: 80px"
                  type="number"
                  :max="999999"
                  :min="1"
                  @input="validatePositiveInteger('ruleDTO.giveTimes')"
                ></el-input>
                次游戏机会
                <el-tooltip
                  class="mt2"
                  effect="light"
                  placement="bottom"
                >
                <template slot="content">
                  <div class="game-givetips">活动期间赠送给用户游戏次数</div>
                </template>
                  <i style="color: #ccc" class="el-icon-question ml4"></i>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="任务获取:" required>
              <taskComponent
                :taskList.sync="taskDataList"
                :taskOrders.sync="taskOrderList"
                :copySteList.sync="taskLevelList"
                :mainText="mainText"
                :isShowUnit="false"
                :isTrueEdit="true"
                :isDisabled="true"
                :activityData="activityData"
                :activityStartTime="activityStartTime"
                :activityEndTime="activityEndTime"
                :hasSelectGoods="hasSelectGoods"
              />
            </el-form-item>
            <el-form-item label="游戏次数限制:">
              <div class="limit">
                活动期间每人每天最多玩游戏
                <el-input
                  class="ml4 mr4"
                  v-model.number="ruleDTO.gameCntLimit"
                  placeholder="请输入..."
                  style="width: 80px"
                  type="number"
                  :max="999999"
                  :min="1"
                  @input="validatePositiveInteger('ruleDTO.gameCntLimit')"
                ></el-input>
                次
              </div>
            </el-form-item>
          </div>
          <!-- 奖品设置 -->
          <jd-title label="奖品设置"></jd-title>
          <div class="mt20">
            <el-form-item label="奖品获取类型:" required>
              <el-radio-group
                v-model="ruleDTO.prizeGetType"
                :disabled="isStartEdit"
                @change="prizeTypeChange"
              >
                <el-radio :label="0">游戏抽奖</el-radio>
                <el-radio :label="1">游戏领奖</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="ruleDTO.prizeGetType == 0">
              <el-form-item label="抽奖分值:" required>
                <div class="limit">
                  <p>
                    满
                    <el-input
                      v-model.number="ruleDTO.scoreLimit"
                      placeholder="请输入..."
                      style="width: 80px"
                      type="number"
                      :max="999999"
                      :min="1"
                      @input="validatePositiveInteger('ruleDTO.scoreLimit')"
                    ></el-input>
                    分，可参与抽奖
                  </p>
                </div>
              </el-form-item>
              <el-form-item label="中奖限制:">
                <div class="limit">
                  <p>
                    活动期间每人每天中奖不超过
                    <el-input
                      v-model.number="ruleDTO.oneDayMaxRewardNumber"
                      placeholder="请输入..."
                      style="width: 80px"
                      type="number"
                      :max="999999"
                      :min="1"
                      @input="
                        validatePositiveInteger('ruleDTO.oneDayMaxRewardNumber')
                      "
                    ></el-input>
                    次，累计最多中奖
                    <el-input
                      v-model.number="ruleDTO.totalMaxRewardNumber"
                      placeholder="请输入..."
                      style="width: 80px"
                      type="number"
                      :max="999999"
                      :min="1"
                      @input="
                        validatePositiveInteger('ruleDTO.totalMaxRewardNumber')
                      "
                    ></el-input>
                    次
                  </p>
                </div>
              </el-form-item>
              <!-- 奖品设置组件 -->
              <el-form-item label="奖品设置:" required>
                <lotteryPrize
                  :prizeSettingList.sync="prizeSettingList"
                  :activityData="activityData"
                  :valueRow="valueRow"
                  :backgroundOpacity="backgroundOpacity"
                  :isDisabled="activityData.isStart"
                  :actType="71"
                  :actEndTime="ruleForm.endTime"
                >
                </lotteryPrize>
              </el-form-item>
            </div>
            <div v-else>
              <!-- 奖品设置组件 -->
              <el-form-item label="奖品设置:" required>
                <span class="tip-color"
                  >多局游戏分数累计阶梯式领取奖品，兑换奖品后，分值会进行核减</span
                >
                <newPrizeTable
                  :prizeList.sync="prizeList"
                  :isDisabled="activityData.isStart"
                  :tableInfo="tableInfo"
                  :isShowAdd="isShowAdd"
                  :valueRow="valueRow"
                  :maxPrizeCount="maxPrizeCount"
                  @addPrize="addPrizeList"
                >
                  <template #dailyLimitName="{ scopeRow }">
                    <dailyLimitConfig
                      :row="scopeRow"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                    ></dailyLimitConfig>
                  </template>
                  <!-- 作用域插槽实现额外字段的输入 -->
                  <template #scoreName="{ scopeRow, scopeIndex }">
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="scopeRow.exchangeScore"
                      placeholder="请输入"
                      style="width: 90px"
                      type="number"
                      :max="999999"
                      :min="1"
                      @input="validateArriveLimitInteger(scopeRow)"
                      @blur="checkArriveLimit(scopeRow, scopeIndex)"
                    ></el-input>
                    分
                  </template>
                </newPrizeTable>
              </el-form-item>
              <el-form-item label="兑换奖品限制:">
                <div class="limit">
                  每个奖品仅支持兑换1次，活动期间每人可兑换
                  <el-input
                    :disabled="isStartEdit"
                    v-model.number="ruleDTO.prizeLimit"
                    placeholder="请输入..."
                    style="width: 80px"
                    class="ml4 mr4"
                    @input="
                      ruleDTO.prizeLimit = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )
                    "
                    @blur="checkExchangeNum()"
                  ></el-input>
                  个奖品<span style="color: #f59a23; margin-left: 10px"
                    >不输入则每个阶梯的奖品都支持领取</span
                  >
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- :widthNumber="750"
            :heightNumber="1650" -->
          <!-- 活动页设置 -->
          <activityPageSettings
            isShowShopName
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="commonTemplateList"
            :templateId="templateId"
            :isShowDesignNumber="false"
            previewKey="url"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="1650"
            :isNeedCustomerPaperworkData="false"
            :isCustomPreview="true"
            :downloadTemplateUrl="templateUrl"
            :designSpecificationsUrl="designSpecificationsUrl"
            v-model="customerPaperwork"
            @selectTemplate="selectTemplate"
          >
            <template #customPreview>
              <knockKnockJoke
                v-if="ruleDTO.gameMode == 0"
                slot="customPreview"
                :ruleForm="{
                  ...customerPaperwork,
                  gameTime: ruleDTO.gameTime,
                  gameScorePer: ruleDTO.gameScorePer,
                }"
                :templateObj="templateObj"
              ></knockKnockJoke>
              <catchingDolls
                v-if="ruleDTO.gameMode == 1"
                slot="customPreview"
                :ruleForm="{
                  ...customerPaperwork,
                  gameTime: ruleDTO.gameTime,
                  gameScorePer: ruleDTO.gameScorePer,
                }"
                :templateObj="templateObj"
              ></catchingDolls>
            </template>
            <template #otherSet>
              <!-- 自定义活动页设置 -->
              <el-form-item label="游戏封面图:">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 1)"
                    :on-success="(res) => handleUploadUI(res, 1)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.url6">
                      <img :src="customerPaperwork.url6" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.url6 = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：750*1650px</span>
                </div>
              </el-form-item>
              <el-form-item label="地洞:" v-if="ruleDTO.gameMode == 0">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 2)"
                    :on-success="(res) => handleUploadUI(res, 2)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.url2">
                      <img :src="customerPaperwork.url2" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.url2 = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：200*110px</span>
                </div>
              </el-form-item>
              <el-form-item
                label="游戏指引区域:"
                label-position="left"
                v-if="ruleDTO.gameMode == 1"
              >
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 3)"
                    :on-success="(res) => handleUploadUI(res, 3)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.url2">
                      <img :src="customerPaperwork.url2" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.url2 = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：652*182px</span>
                </div>
              </el-form-item>
              <el-form-item label="地洞-遮挡:" v-if="ruleDTO.gameMode == 0">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 4)"
                    :on-success="(res) => handleUploadUI(res, 4)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.url3">
                      <img :src="customerPaperwork.url3" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.url3 = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：200*110px</span>
                </div>
              </el-form-item>
              <el-form-item label="礼盒:" v-if="ruleDTO.gameMode == 0">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 5)"
                    :on-success="(res) => handleUploadUI(res, 5)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.url4">
                      <img :src="customerPaperwork.url4" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.url4 = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：200*110px</span>
                </div>
              </el-form-item>
              <el-form-item label="品牌logo:">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 6)"
                    :on-success="(res) => handleUploadUI(res, 6)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.logoUrl">
                      <img :src="customerPaperwork.logoUrl" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.logoUrl = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：200*100px</span>
                </div>
              </el-form-item>
              <el-form-item label="按钮设置:">
                <div class="btn_boxs">
                  <div class="flexc">
                    <span>背景：</span>
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="(file) => beforeUploadUI(file, 7)"
                      :on-success="(res) => handleUploadUI(res, 7)"
                    >
                      <div class="bg-wrap" v-if="customerPaperwork.url5">
                        <img :src="customerPaperwork.url5" class="bg-wrap-img" />
                      </div>
                      <jd-button
                        :disabled="backgroundOpacity"
                        v-else
                        type="blueText"
                        >自定义上传</jd-button
                      >
                    </el-upload>
                    <jd-button
                      type="blueText"
                      class="ml16"
                      :disabled="backgroundOpacity"
                      @click="customerPaperwork.url5 = ''"
                      >重置</jd-button
                    >
                    <span class="size-tip"
                      >尺寸建议：{{
                        ruleDTO.gameMode == 1 ? "354*130px" : "376*136px"
                      }}</span
                    >
                  </div>
                  <div class="flexc" style="margin-top: 20px">
                    <span>文字：</span>
                    <el-color-picker
                      v-model="customerPaperwork.rgb"
                      :disabled="backgroundOpacity"
                      class="colorPicker"
                    >
                    </el-color-picker>
                    <jd-button
                      class="ml16"
                      type="blueText"
                      :disabled="backgroundOpacity"
                      @click="customerPaperwork.rgb = currrentRgb"
                      >重置</jd-button
                    >
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="进度条颜色:">
                <div class="flexc-cen-x">
                  <el-color-picker
                    v-model="customerPaperwork.rgb2"
                    :disabled="backgroundOpacity"
                    class="colorPicker"
                  >
                  </el-color-picker>
                  <jd-button
                    class="ml16"
                    type="blueText"
                    :disabled="backgroundOpacity"
                    @click="customerPaperwork.rgb2 = currrentRgb2"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="背景音乐设置:" label-position="left">
                <div class="btn_boxs">
                  <div class="flexc-cen-x">
                    <span>音乐设置：</span>
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :disabled="backgroundOpacity"
                      :show-file-list="false"
                      :before-upload="beforeUploadMusic"
                      :on-success="(res) => handleUploadMusic(res)"
                    >
                      <jd-button :disabled="backgroundOpacity" type="blue"
                        >添加背景音乐({{
                          customerPaperwork.customizeJson ? 1 : 0
                        }}/1)</jd-button
                      >
                    </el-upload>
                    <span class="size-tip">格式:MP3，大小5M以内</span>
                  </div>
                  <div class="flexc-cen-x mt20">
                    <span>按钮颜色：</span>
                    <el-radio-group v-model="customerPaperwork.rgb3">
                      <el-radio label="1">白色</el-radio>
                      <el-radio label="2">灰色</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="音效配置:">
                <el-radio-group v-model="customerPaperwork.musicOpen">
                  <el-radio :label="0">不开启</el-radio>
                  <el-radio :label="1">开启</el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
          </activityPageSettings>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity" 
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  saveActivityCommon,
  getActivityDetailCommon,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import knockKnockJoke from "./components/newActPreviews/funGames/knockKnockJoke.vue";
import catchingDolls from "./components/newActPreviews/funGames/catchingDolls.vue";
import taskComponent from "./components/_components/taskComponent.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import lotteryPrize from "./components/lotteryPrize/index.vue";
import {
  conditionValue,
  getTaskTypeOptions,
} from "./components/taskCommonField/index.js";
import {
  useInputTaskData,
  useOutputTaskData,
} from "./components/commDataHook/useTaskData.js";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
// import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    knockKnockJoke,
    catchingDolls,
    taskComponent,
    newPrizeTable,
    lotteryPrize,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mainText: "游戏机会",
      taskLevelList: [],
      isForceRemind: 0,
      isKeyActivity: 0,
      placementPosition: [],
      conditionValue: conditionValue,
      maxPrizeCount: 20,
      isShowAdd: true,
      hasSelectGoods: [],
      taskDataList: [],
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      customerPaperwork: {
        url6: "", // 游戏封面图
        url2: "", // 地洞/游戏指引图
        url3: "", // 地洞遮挡图
        url4: "", // 礼盒图
        logoUrl: "", // 品牌logo
        url5: "", // 按钮背景图
        rgb: "#ffffff", // 按钮字体颜色
        rgb2: "#A579DF", // 进度条颜色
        customizeJson: "", // 背景音乐
        rgb3: '1', // 1 白色 2灰色
        musicOpen: 1, // 0 关闭 1 开启
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
      },
      ruleDTO: {
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "https://cdn-image.yucrm.cn/hd/images/knocking-share.png",
        openCardStartTime: "",
        openCardEndTime: "",
        // 活动设置字段
        gameMode: 0,
        gameTime: 60,
        gameScorePer: 10,
        // foreScoreTotal: 0,
        giveTimes: "",
        gameCntLimit: "",
        // 奖品字段
        prizeGetType: 0,
        oneDayMaxRewardNumber: "",
        totalMaxRewardNumber: "",
        prizeLimit: "",
        scoreLimit: "",
      },
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      prizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          exchangeScore: null, // 兑换分值
          singleAmount: "",
        },
      ],
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
      ],
      tableInfo: [
        {
          prop: "exchangeScore",
          label: "到达分值",
          slot: "scoreSlot",
          slotName: "scoreName",
          minWidth: 120,
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 100,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slot: "totalAmountSlot",
          minWidth: 120,
        },
        {
          label: "每日发放限额",
          slotName: "dailyLimitName",
          slot: "dailyLimit",
          width: 120,
        },
        {
          label: "图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 120,
        },
        {
          label: "操作",
          minWidth: "90px",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 142,
        },
      ],
      taskOrderList: []
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    commonTemplateList() {
      let list = this.giftList.filter(
        (item) => item.layout - 1 == this.ruleDTO.gameMode
      );
      return list;
    },
    templateUrl() {
      return this.ruleDTO.gameMode == 0
        ? "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/qql.psd"
        : "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/zww.psd";
    },
    designSpecificationsUrl() {
      let urls = {
        0: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/qiaoqiaole.png",
        1: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/zhuawawa.png",
      };
      return urls[this.ruleDTO.gameMode];
    },
    taskTypeOptions() {
      return getTaskTypeOptions("游戏");
    },
  },
  created() {
    this.calculateNum();
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.getDetail();
    this.buriedPoint(1, "趣味游戏", "互动管理", "互动活动");
  },

  methods: {
    // 验证到达分值正整数
    validateArriveLimitInteger(scopeRow) {
      if (!scopeRow) return;

      let value = scopeRow.exchangeScore;

      // 移除所有非数字字符
      value = String(value).replace(/[^0-9]/g, "");

      // 转换为数字
      value = Number(value);

      // 确保在有效范围内
      if (value < 1) {
        value = "";
      } else if (value > 999999) {
        value = 999999;
      }
      // 更新值
      scopeRow.exchangeScore = value;
    },
    handlePrizeLimit(row, rowIndex) {
      return this.prizeList.some((item, index) => {
        if (index < rowIndex) {
          if (
            Number(item.exchangeScore) > 0 &&
            Number(item.exchangeScore) >= Number(row.exchangeScore)
          ) {
            this.$message.warning("到达分值下一梯度需大于前一梯度");
            return true;
          }
        } else if (index > rowIndex) {
          if (
            Number(item.exchangeScore) > 0 &&
            Number(item.exchangeScore) <= Number(row.exchangeScore)
          ) {
            this.$message.warning("到达分值下一梯度需大于前一梯度");
            return true;
          }
        }
      });
    },
    // 检查到达分值是否符合要求
    checkArriveLimit(row, rowIndex) {
      let flag = this.handlePrizeLimit(row, rowIndex);
      if (flag) {
        row.exchangeScore = "";
      }
    },
    prizeTypeChange(val) {
      this.toAddIndex = 0;
      this.prizeIndex = -1;
      this.prizeList = [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          exchangeScore: null, // 兑换分值
          singleAmount: "", //
        },
      ];
      this.prizeSettingList = [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
      ];
    },

    checkExchangeNum() {
      if (Number(this.ruleDTO.prizeLimit) > this.prizeList.length) {
        this.ruleDTO.prizeLimit = "";
        this.$message.warning("不可超过奖奖品总数");
      }
    },
    gainDrawNumberTypeChange(val) {
      if (val == 0) {
        this.ruleDTO.sharePic =
          "https://cdn-image.yucrm.cn/hd/images/knocking-share.png";
      } else {
        this.ruleDTO.sharePic =
          "https://cdn-image.yucrm.cn/hd/images/claw-crane-share.png";
      }
      this.templateId = this.commonTemplateList[0].id;
      this.templateObj = this.commonTemplateList[0];
      this.initCustomizeData(this.templateObj);
      // this.calculateNum();
    },
    validatePositiveInteger(path) {
      // 解析路径获取对象和属性名
      const [objName, propName] = path.split(".");
      const obj = this[objName];
      if (!obj || !propName) return;

      let value = obj[propName];

      // 移除所有非数字字符
      value = String(value).replace(/[^0-9]/g, "");

      // 转换为数字
      value = Number(value);

      // 确保在有效范围内
      if (value < 1) {
        value = "";
      } else if (value > 999999) {
        value = 999999;
      }

      // 更新值
      this.$set(obj, propName, value);
    },
    calculateNum() {
      if (this.ruleDTO.gameMode == 1) {
        this.ruleDTO.foreScoreTotal =
          (this.ruleDTO.gameTime / 3) * this.ruleDTO.gameScorePer;
      } else {
        // 计算不同时间段的地鼠数量
        const totalTime = this.ruleDTO.gameTime;
        const firstPhaseTime = totalTime * 0.25;
        const secondPhaseTime = totalTime * 0.4;
        const thirdPhaseTime = totalTime * 0.35;

        // 各阶段地鼠数量（向下取整）
        const firstPhaseMoles = Math.floor(firstPhaseTime / 1.4);
        const secondPhaseMoles = Math.floor(secondPhaseTime / 1.2);
        const thirdPhaseMoles = Math.floor(thirdPhaseTime / 0.9);

        // 总地鼠数
        const totalMoles = firstPhaseMoles + secondPhaseMoles + thirdPhaseMoles;

        // 计算总分值
        this.ruleDTO.foreScoreTotal = totalMoles * this.ruleDTO.gameScorePer;
      }
    },
    addPrizeList() {
      if (this.prizeList.length >= this.maxPrizeCount) {
        this.$message.warning(`最多只能添加${this.maxPrizeCount}个奖项`);
        return;
      }
      this.prizeList.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: 0,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        exchangeScore: null, // 兑换分值
        singleAmount: "",
      });
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      let sizeype = {
        1: {
          width: 750,
          height: 1650,
        },
        2: {
          width: 200,
          height: 110,
        },
        3: {
          width: 652,
          height: 182,
        },
        4: {
          width: 200,
          height: 110,
        },
        5: {
          width: 160,
          height: 160,
        },
        6: {
          width: 200,
          height: 100,
        },
        7: {
          width: 376,
          height: 136,
        },
        8: {
          width: 354,
          height: 130,
        },
      };
      if (type == 7) {
        if (this.ruleDTO.gameMode == 0) {
          type = 8;
        }
      }
      const status = await this.imgchecked(
        file,
        sizeype[type].width,
        sizeype[type].height
      );
      if (!status) {
        return false;
      }
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.url6 = res.data;
          this.$message.success("游戏封面图上传成功");
        } else if (type == 2) {
          this.customerPaperwork.url2 = res.data;
          this.$message.success("地洞图上传成功");
        } else if (type == 3) {
          this.customerPaperwork.url2 = res.data;
          this.$message.success("游戏指引区域图上传成功");
        } else if (type == 4) {
          this.customerPaperwork.url3 = res.data;
          this.$message.success("地洞-遮挡上传成功");
        } else if (type == 5) {
          this.customerPaperwork.url4 = res.data;
          this.$message.success("礼盒图上传成功");
        } else if (type == 6) {
          this.customerPaperwork.logoUrl = res.data;
          this.$message.success("品牌logo上传成功");
        } else if (type == 7) {
          this.customerPaperwork.url5 = res.data;
          this.$message.success("按钮背景图上传成功");
        }
      }
    },
    async beforeUploadMusic(file, fileList, item) {
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".mp3"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("文件格式不符合要求，请重新上传");
        return Promise.reject();
      }
      const isLt3M = file.size < 1024 * 1024 * 5;
      if (!isLt3M) {
        this.$message.info("文件大小不符合要求，请重新上传");
        return Promise.reject();
      }
    },
    // 上传成功
    handleUploadMusic(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.customerPaperwork.customizeJson = res.data;
        this.$message.success("上传成功");
      }
    },
    initCustomizeData(row) {
      let configJson = row.configJson && JSON.parse(row.configJson);
      this.customerPaperwork.rgb = row.rgb||'#ffffff';
      this.customerPaperwork.rgb2 = row.rgb2||'#A579DF';
      this.customerPaperwork.rgb3 = row.rgb3||'1';
      this.customerPaperwork.customizeJson = configJson.customizeJson;
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.commonTemplateList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.commonTemplateList.filter(
          (item) => item.id == this.templateId
        );
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        let configJson =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson);
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
        this.customerPaperwork.customizeJson = this.customerPaperwork
          .customizeJson
          ? this.customerPaperwork.customizeJson
          : configJson.customizeJson;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //生成规则
    generateRule() {
      let text1 = "",
        text2 = "游戏机会：",
        text3 = "",
        text4 = "奖品数量有限，先到先得；",
        text5 = "若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【注意事项】";
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      if (this.ruleDTO.giveTimes) {
        text2 += `初始赠送${this.ruleDTO.giveTimes}次游戏机会；`;
      }
      text2 += `${
          this.taskDataList.length > 0 ? "完成相应任务可获得游戏次数；" : ""
        }`;
      if (this.ruleDTO.gameMode == 0) {
        text1 = `游戏说明：在${
          this.ruleDTO.gameTime
        }秒内进行敲敲乐游戏，敲中一个元素得分${this.ruleDTO.gameScorePer}分，${
          this.ruleDTO.prizeGetType == 0
            ? `单次游戏超过${this.ruleDTO.scoreLimit}分，可参与抽奖；`
            : `多局游戏分数累计可阶梯式领取奖品，兑换奖品后，分值会进行核减，每个奖品仅支持兑换1次，活动期间每人可兑换${
                !this.ruleDTO.prizeLimit
                  ? this.prizeList.length
                  : this.ruleDTO.prizeLimit
              }个奖品；`
        }`;
      } else {
        text1 = `游戏说明：在${
          this.ruleDTO.gameTime
        }秒内进行抓娃娃游戏，抓到一个娃娃得分${this.ruleDTO.gameScorePer}分，${
          this.ruleDTO.prizeGetType == 1
            ? `多局游戏分数累计可阶梯式领取奖品，兑换奖品后，分值会进行核减，每个奖品仅支持兑换1次，活动期间每人可兑换${
                !this.ruleDTO.prizeLimit
                  ? this.prizeList.length
                  : this.ruleDTO.prizeLimit
              }个奖品；`
            : `单次游戏超过${this.ruleDTO.scoreLimit}分，可参与抽奖；`
        }`;
      }
      if (this.ruleDTO.gameCntLimit) {
        text3 = `活动期间每人每天最多玩游戏${this.ruleDTO.gameCntLimit}次；`;
      } else {
        text3 = "";
      }
      let Arr1 = [
        firstText,
        [secondText, text1, text2, text3, text4, text5],
        [thirdText, precautions],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "、" + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }

      if (!this.ruleDTO.gameTime) {
        this.$message.warning("请填写游戏设置");
        return;
      }
      if (!this.ruleDTO.gameScorePer) {
        this.$message.warning("请填写游戏设置");
        return;
      }
      // if (!this.ruleDTO.giveTimes) {
      //   this.$message.warning("请填写赠送游戏机会");
      //   return;
      // }
      if (this.taskDataList.length == 0) {
        this.$message.warning("请添加任务");
        return;
      }
      if (this.ruleDTO.prizeGetType != 1 && !this.ruleDTO.scoreLimit) {
        this.$message.warning("请填写抽奖分值");
        return;
      }
      if (this.ruleDTO.prizeGetType == 1) {
        for (let item of this.prizeList) {
          if (!item.exchangeScore) {
            this.$message.warning("请填写奖品设置-到达分值");
            return;
          }
          if (item.title == "") {
            this.$message.warning("请完善奖品设置信息");
            return;
          }
          if (!item.totalAmount) {
            this.$message.warning("请完善奖品设置信息");
            return;
          }
        }
      }
      if (this.ruleDTO.prizeGetType == 1) {
        for (let i = 0; i < this.prizeList.length; i++) {
          if (i > 0) {
            if (
              this.prizeList[i].exchangeScore <=
              this.prizeList[i - 1].exchangeScore
            ) {
              this.$message.warning("到达分值下一梯度需大于前一梯度");
              return;
            }
          }
        }
      } else {
        let isFlay = this.prizeSettingList.some((item) => {
          if (item.prizeType != 9) {
            return !item.totalAmount;
          }
        });
        if (this.prizeSettingList.every((item) => item.prizeType == 9)) {
          this.$message.warning("请选择奖品！");
          return;
        }
        if (isFlay) {
          this.$message.warning("请填写奖品总数！");
          return;
        }
        // 检查是否至少有一个谢谢参与奖品
        const hasThankYou = this.prizeSettingList.some(
          (item) => item.prizeType == 9
        );
        if (!hasThankYou) {
          this.$message.warning("奖品设置请至少保留1个谢谢参与!");
          return;
        }
      }

      if (
        this.ruleDTO.prizeGetType == 1 &&
        this.ruleDTO.prizeLimit > this.prizeList.length
      ) {
        this.$message.warning("兑换奖品次数不可超过奖品总数");
        return;
      }

      if (!this.templateId) {
        return this.$message.warning("请选择活动模板");
      }
      // 公活动配置校验
      // if (!useValidateMoreActSet(this)) {
      //   return;
      // }
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    async handleDialogCloseAnoth() {
      let ruleDTO = {
        ...this.ruleDTO,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        isForceRemind: this.isForceRemind,
        taskList: [],
      };
      let obj = {
        ...this.ruleForm,
        subType: 71,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        placementPosition: this.placementPosition.join(","),
        isKeyActivity: this.isKeyActivity,
      };
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      // 奖品处理
      let prizeListCommon = [];
      if (this.ruleDTO.prizeGetType == 0) {
        obj.pointActivityPrizeDTOList = this.deepClone(this.prizeSettingList);
        obj.pointActivityPrizeDTOList.forEach((item, index) => {
          item.percentage = Number(item.percentage);
          item.memberBuyPercentage = Number(item.memberBuyPercentage);
          if (item.prizeType != 9) {
            if (item.prizeType == 3 || item.prizeType == 10) {
              item.assetsId = item.skuId || item.assetsId;
            } else {
              item.singleAmount = 1;
            }
            if (item.prizeType == 2 || item.prizeType == 4) {
              item.singleAmount = item.price;
            }
          }
        });
      } else {
        obj.pointActivityPrizeDTOList = this.prizeList.filter(
          (item) => item.prizeType > 0
        );
      }
      prizeListCommon = obj.pointActivityPrizeDTOList;
      // 任务
      if (this.taskDataList.length) {
        obj.ruleDTO.taskList = useInputTaskData(this.taskDataList);
      } else {
        obj.ruleDTO.taskList = [];
      }
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeListCommon.map((item) => {
              return {
                ...item,
                prizeId: item.id,
                title: item.title,
              };
            }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            taskList: obj.ruleDTO.taskList,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveActivityCommon(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              placementPosition,
              isKeyActivity,
              studentSatus,
            } = res.data;
            const {
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
              taskList,
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");

            this.ruleForm.condFollow = condFollow ? true : false;
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            this.ruleDTO = ruleDto;
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity || 0;
            this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];
            // 任务回显
            if (taskList.length > 0) {
              this.taskDataList = useOutputTaskData(taskList, this);
            }
            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
              //奖品回显
              if (this.ruleDTO.prizeGetType == 0) {
                this.prizeSettingList = pointActivityPrizeDTOList;
                this.prizeSettingList.forEach((item, index) => {
                  item.minNum = item.totalAmount;
                  item.index = index;
                  item.isWrite = false;
                  if (item.percentage) {
                    this.winningRate += Number(item.percentage);
                  }
                });
              } else {
                this.prizeList =
                  pointActivityPrizeDTOList && pointActivityPrizeDTOList.length
                    ? pointActivityPrizeDTOList
                    : [
                        {
                          assetsId: null, // 资产项id(计划id优惠卷id商品id)
                          prizeType: 0,
                          price: null,
                          logo: null,
                          title: "",
                          totalAmount: null,
                          exchangeScore: null, // 兑换分值
                          singleAmount: "",
                        },
                      ];
              }
            }
            if (this.activityData.isCopy) {
              this.ruleForm.ruleDescription = "";
            }
            this.templateId = templateId;
            this.getPolite();
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.game-givetips{
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }

  .bg-wrap {
    width: 80px;
    overflow: hidden;
    &-img {
      width: 100%;
      height: auto;
    }
  }

  .invite-box {
    background-color: #f7f8fa;
    padding: 16px;
    border-radius: 8px;
  }

  .ml12 {
    margin-left: 12px;
  }

  .ml8 {
    margin-left: 8px;
  }

  .ml20 {
    margin-left: 20px;
  }

  .mlr8 {
    margin: 0 8px;
  }

  .w90 {
    width: 90px;
  }
  .w125 {
    width: 125px;
  }
  .w150 {
    width: 150px;
  }
  .w180 {
    width: 180px;
  }

  .tip-color {
    color: #666;
  }

  .logo-style {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .text-red {
    color: #ff4d4f;
  }
  .size-tip {
    color: #aaaaaa;
    margin-left: 8px;
  }
  .btn_boxs {
    background-color: rgb(248, 249, 252);
    padding: 16px;
    border-radius: 4px;
    width: 500px;
  }
  .limit {
    display: flex;
    align-items: center;
    color: #333333;
  }
}
/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
</style>
